@if (bookingProfileService.companyBookingProfiles | async; as bookingProfiles) {
  @for (bp of bookingProfiles; track bp) {
    @if (!companyService.isBookingProfileRestricted || companyService.restrictedBookingProfileIds?.includes(bp.id!)) {
    <div class="flex flex-col w-full">
      <form #a="ngForm" class="flex flex-row justify-between items-center h-10">
        <div class="w-full text-sm">{{ bp.title }}</div>
        <mat-checkbox [checked]="isBookingProfileChecked(bp.id)"
          (change)="handleBpClick.emit({state: $event.checked, bp: bp})"
          (click)="$event.stopPropagation()"
          [disabled]="isBookingProfileChecked(bp.id) && bookingProfilesInCalendar.length === 1">
        </mat-checkbox>
      </form>
    </div>
    }
  }
}